import { defineStore } from "pinia";
import axios from 'axios';

export const useUserStore = defineStore('userStore',() => {
    const apiUrl = "api/v1/user/";
             
    async function validateNewPassword(userInfo: string, newPassword: string) {
        try {
            const data = await axios.get(`${apiUrl}${userInfo}/validate-password/${newPassword}`);
            return data.data;                
        }
        catch (error:any) {
            console.error(error?.response?.statusText);
            return `Error encountered while trying to validate new password(${error?.response?.statusText}).`
        }
    }

    function validateResetCode(userInfo: string, resetCode:string){
        try {
            let encodedResetCode = encodeURIComponent(resetCode);
            return axios.get(`${apiUrl}${userInfo}/reset-code/${encodedResetCode}/verify`);              
        }
        catch (error:any) {
            console.error(error?.response?.statusText);
        }
    }

    function sendPasswordResetRequest(userInfo: string) {
        try {
            return axios.get(`${apiUrl}${userInfo}/reset-password`);              
        }
        catch (error:any) {
            console.error(error?.response?.statusText);
        }
    }

    function postPasswordChangeInformation(userInfo: string, password:string, resetCode:string){
        try {
            return axios.post(`${apiUrl}${userInfo}/reset-password`, { password: password, resetCode: resetCode });              
        }
        catch (error:any) {
            console.error(error?.response?.statusText);
        }
    }
    
    return {validateNewPassword, validateResetCode, sendPasswordResetRequest, postPasswordChangeInformation}
})